import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { TempurLoveBreadcrumbs } from "../components/TempurLoveBreadcrumbs";
import { TempurLoveGrid } from "../components/TempurLoveGrid";

type IProps = Immutable<templates.TempurLoveGridTemplate>;

/**
 * Default template for sites that don't have TempurLove features.
 * Sites with active TempurLove features should provide their own layout
 * in their site-specific template files.
 */
export const Template = (props: IProps): React.JSX.Element => {
    return (
        <>
            {props.breadcrumb_items && (
                <TempurLoveBreadcrumbs
                    items={props.breadcrumb_items}
                    className="al-tlovegrid-breadcrumbs"
                />
            )}
            <TempurLoveGrid
                baseApiUrl={props.base_api_url}
                filterBy={props.filter_by}
                initialGridData={props.initial_grid_data}
                initialNextUrl={props.initial_next_url}
                useCappedWidth={true}
                rootUrl={props.root_url}
            />
        </>
    );
};
